import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-sales-phone-register-manual-general-instructions',
  templateUrl: './sales-phone-register-manual-general-instructions.component.html',
  styles: [
  ]
})
export class SalesPhoneRegisterManualGeneralInstructionsComponent {
  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Registro teléfono'];
  route = inject(ActivatedRoute);

  @Output() step = new EventEmitter();
  @Output() visibleModalEntryIMEI = new EventEmitter();

  onIntroduceIMEI() {
    this.visibleModalEntryIMEI.emit(true);
    this.step.emit('introduce-imei');
  }

  onSearchIMEI(){
    this.step.emit('imei-instructions');
  }
}
